import * as React from 'react'
import classNames from 'classnames'
import s from './divider.scss'
import {DividerProps} from '.'

export const Divider = ({className}: DividerProps) => <div className={classNames(s.divider, className)} />
